import React, { useEffect, useState, useReducer } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Switch from '@mui/material/Switch';
import { Box } from '@mui/system';
import { setSnackBarAlert, findAllTeamGroups, caughtError } from '../../redux';
import getAppConfig from '../../config';
const config = getAppConfig();

const initialState = {
   groupName: '',
   shortCode: '',
   active: false
}

const reducer = (state, action) => {
  return {
  ...state,
  ...action
  }
}

const EditForm = (props) => {

  const [state, updateState] = useReducer(reducer, initialState);
  const [loading, setLoading] = useState(true);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const dispatch = useDispatch();

  const handleInputChange = (event) => {
    if(event.target.type === 'checkbox'){
      updateState({ [event.target.name]: event.target.checked });
    } else {
      updateState({ [event.target.name]: event.target.value });
    }
  }

  useEffect(() => {
    if(loading && props.modalDiaLogId && props.modalDiaLogId > 0) {
      let URL = `${config.api.URL}/team-group/${props.modalDiaLogId}`;
      axios.get(URL).then(response => {
        updateState({
          groupName: response.data.data.groupName,
          shortCode: response.data.data.shortCode,
          active: Boolean(response.data.data.active)
        })
        setBtnDisabled(false);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
        console.log(error);
      })
    }
  }, [loading, props]);

  const handleSubmit = (event) => {
    event.preventDefault();

    if(state.groupName === '') {
      dispatch(setSnackBarAlert({
        openSnackBar: true,
        severity: 'error',
        message: `groupName is required`
      }));
      return false;
    }

    if(state.shortCode === '') {
      dispatch(setSnackBarAlert({
        openSnackBar: true,
        severity: 'error',
        message: `shortCode is required`
      }));
      return false;
    }

    setBtnDisabled(true);

    axios.patch(`${config.api.URL}/team-group/${props.modalDiaLogId}`,state).then(response => {
      dispatch(findAllTeamGroups(props.filterInput));
      props.setOpen(false);
    }).catch(error => {
      setBtnDisabled(false);
      dispatch(caughtError(error));
    })

  }


  return (
    <form onSubmit={handleSubmit}>
      <DialogContent sx={{ marginTop: "-20px" }} >

        <TextField
          value={state.groupName}
          onChange={handleInputChange}
          name="groupName"
          label="TeamGroup Name"
          margin="dense"
          type="text"
          fullWidth
          variant="outlined"
          required
        />

        <TextField
          value={state.shortCode}
          onChange={handleInputChange}
          name="shortCode"
          label="ShortCode"
          margin="dense"
          type="text"
          fullWidth
          variant="outlined"
          required
        />

        <Box>
          <FormControlLabel className="float-end" control={<Switch name="active" checked={state.active} onChange={handleInputChange} />} label="Active" labelPlacement="start" />
        </Box>


      </DialogContent>
      <DialogActions>
        <button className="btn btn-secondary" onClick={ (e) => {
            e.preventDefault();
            props.setOpen(false);
          } }>Cancel</button>
        <button disabled={btnDisabled} type="submit" className="btn btn-primary" >Update TeamGroup</button>
      </DialogActions>
    </form>
  )

}


export default EditForm;
